// fonction qui scrolle en bas de la page automatiquement
export function scrollToBottom() {
  document.getElementById("message-bottom").scrollIntoView();
}
